var map = {
	"./404.svg": "8e71",
	"./Biology.jpg": "4db5",
	"./about/Jumbotron.jpg": "c224",
	"./background-pattern/dust_scratches.png": "15d7",
	"./background-pattern/solid.png": "61a1",
	"./bg-footer.svg": "f99a",
	"./dashboard_background/dashboard_background.png": "995e",
	"./dashboard_background/fabric_1.zip": "0283",
	"./index-carousel/Carousel1.jpg": "282a",
	"./index-carousel/Carousel2.jpg": "10c6",
	"./index-carousel/Carousel3.jpg": "62e6",
	"./index-pictures/books.jpg": "75bc",
	"./index-pictures/library.jpg": "7bb9",
	"./index-pictures/subjects.jpg": "ec3c",
	"./subjects_img/Biology.jpg": "cdaf",
	"./subjects_img/Chemistry.jpg": "9fc1",
	"./subjects_img/Computer Science.jpg": "b8d9",
	"./subjects_img/English.jpg": "3b17",
	"./subjects_img/Mathematics.jpg": "f261",
	"./subjects_img/Physics.jpg": "c2c7",
	"./temp-pics/navbar.png": "1c7a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";